import { ChangeDetectionStrategy, Component, forwardRef, inject, input } from '@angular/core';
import { NgIcon } from '@ng-icons/core';
import { NgbCollapse } from '@ng-bootstrap/ng-bootstrap';
import type { MenuItemType } from '@shared/types/layout';
import { APP_MENU_NAVIGATION } from '../app-menu-navigation';
import { AppMenuItemComponent } from '../app-menu-item/app-menu-item.component';

@Component({
  selector: 'li[app-menu-item-children]',
  host: { class: 'side-nav-item' },
  imports: [
    NgIcon,
    NgbCollapse,
    AppMenuItemComponent,
    forwardRef(() => AppMenuItemWithChildrenComponent),
  ],
  templateUrl: './app-menu-item-with-children.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppMenuItemWithChildrenComponent {
  readonly item = input.required<MenuItemType>();
  protected readonly nav = inject(APP_MENU_NAVIGATION);

  get collapseState(): boolean {
    return this.item().isCollapsed ?? true;
  }

  set collapseState(value: boolean) {
    this.item().isCollapsed = value;
  }
}
